import { useRef } from "react";
import { useProjectId } from "../../shopdrawing/ProjectName";
import { useAlternative } from "../alternative/Alternative";
import { AutoInsert } from "../../shopdrawing/openings/AutoInsertOpening";
import { jsx as _jsx } from "react/jsx-runtime";
export function MiscPricingAutoInsert(props) { const projectId = useRef(useProjectId()); const alt = useAlternative(); return /*#__PURE__*/ _jsx(AutoInsert, { getInput: () => { return { quoteAlternative: alt ? alt : undefined, project: projectId.current }; }, onDone: props.onDone }); }
